import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';

import { SignalMatchStatusSchema } from '../signal-match-status/signal-match-status';
import { IdentitySignalTypeSchema } from '../signal-type/signal-type';

/**
 * The whitelisted filters of the Trust review queue (N7).
 *
 * Two, and the omissions are the design. `status` is what a reviewer works by —
 * the queue opens on `pending_review` and the resolved rows are still readable,
 * because a `block` that nobody can find afterwards is a refusal nobody can
 * undo. `signalType` is how a run of collisions on one signal is worked
 * together, which is exactly what the retroactive sweep produces when a banned
 * account shared a device with several live members.
 *
 * There is deliberately **no account filter**: `subjectUserId` or
 * `matchedUserId` would turn a work list into a per-member dossier, and
 * `reviewedByUserId` into a way to pull up everything a named colleague decided
 * — the same reason the verification queue has neither.
 */
export const SignalMatchesListQuerySchema = makeListQuery({
  status: SignalMatchStatusSchema.optional(),
  signalType: IdentitySignalTypeSchema.optional(),
});

export type SignalMatchesListQuery = z.infer<typeof SignalMatchesListQuerySchema>;
